import React from "react";
import { usePrescriptionData } from "../hooks/usePrescriptionData";
import { DosageProps } from "../types";
import {
  DosageHeader,
  ErrorState,
  LoadingState,
  PrescriptionContent,
} from "./ui";

const Dosage: React.FC<DosageProps> = ({ rowData }) => {
  const { patientDetails, drugDetails, loading, error } = usePrescriptionData({
    rowId: rowData?.id,
  });

  const headerData = {
    drugQuantity: rowData?.drugQuantity,
    drugDaysSupply: rowData?.drugDaysSupply,
    drugConfidenceScore: rowData?.drugConfidenceScore,
    drugFetchedFrom: rowData?.drugFetchedFrom,
  };

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-2 border-1 border-primaryGray-15 bg-[#F7F9FA]">
      <DosageHeader data={headerData} />
      <div className="flex h-full w-full flex-col">
        {loading ? (
          <div className="flex h-full w-full items-center justify-center">
            <LoadingState />
          </div>
        ) : error ? (
          <div className="flex h-full w-full items-center justify-center">
            <ErrorState error={error} />
          </div>
        ) : (
          <div className="h-full w-full bg-white">
            <PrescriptionContent
              patientDetails={patientDetails}
              drugDetails={drugDetails}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Dosage;
